import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createCostBy = ( {data} : {data: IPostNewCostBy | {}}): Promise<string> => {
  return axiosDefaultApi.post(`api/CostBy/InsertCostBy`, data);
};

type QueryFnType = typeof createCostBy;

type UseCreateCostByOptions = {
  data: IPostNewCostBy | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateCostBy = ({ config }: UseCreateCostByOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της παραμέτρου 'Κόστος ανά'.`, 500);
            console.error('Couldnt create new Cost by', error);
            setIsNotificationVisible(true)
          },
          onSuccess: (response) => {
            queryClient.invalidateQueries(["getAllCostBy"])
            addNotification("Δημιουργήθηκε Νέα παράμετρος 'Κόστος ανά'.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createCostBy,
    })
}